import { errorCode } from '../../api/client';

// Backend error codes from the admin routes, as messages for the admin.
const MESSAGES = {
  network_error: "Can't reach the dashboard server. Check your connection.",
  forbidden: "You don't have admin access.",
  missing_fields: 'First name, last name and email are required.',
  invalid_email: 'Enter a valid email address.',
  email_taken: 'An Aren account already exists for this email.',
  already_admin: 'This person is already an admin.',
  other_organization: 'This email belongs to an account in another organization.',
  admin_limit_reached: 'The maximum number of admin accounts has been reached.',
  email_failed: "We couldn't send the sign-in email, so no account was created. Try again.",
  cannot_delete_self: "You can't remove your own admin access.",
  last_admin: 'At least one admin must remain.',
  not_found: "This record doesn't exist anymore. Refresh the page.",
  data_not_configured: "Handoff data isn't set up for your organization yet. Contact Aren.",
  invalid_unit: 'Choose an active unit.',
  handoff_in_progress: "This patient is in the middle of a handoff in the app. Try again once it's finished.",
  not_on_unit: "That nurse isn't on your unit.",
  nurse_has_patients: 'This nurse still has patients on their current unit. Reassign those patients first, then change their unit.',
};

export function adminErrorMessage(error, fallback) {
  return MESSAGES[errorCode(error)] || fallback;
}
